export const DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME = 'DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME';
export const DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME = 'DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME';
export const SET_PAYMENT_MESSAGE_FOR_REG_HOME = 'SET_PAYMENT_MESSAGE_FOR_REG_HOME';
export const SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME = 'SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME';
export const DISPLAY_BIRTH_DATE_MODAL = 'DISPLAY_BIRTH_DATE_MODAL';
export const DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL = 'DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL';
export const SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT = 'SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT';
export const SET_TOURNAMENT_LOADING_FOR_REG_HOME = 'SET_TOURNAMENT_LOADING_FOR_REG_HOME';



// WEBPACK FOOTER //
// ./src/features/registration/home/constants.js